import { Link } from "react-router-dom";
import { useDocumentMeta } from "@/hooks/useDocumentMeta";
import { getCategories } from "@/lib/news";

const philosophy = [
  { icon: "ri-flashlight-line", title: "快速", desc: "热点发生时第一时间跟进，让读者不错过关键节点。" },
  { icon: "ri-shield-check-line", title: "真实", desc: "坚持多方核实，不为流量妥协内容的准确性。" },
  { icon: "ri-book-open-line", title: "深度", desc: "不满足于表面信息，持续挖掘事件背后的脉络。" },
];

const team = [
  { name: "内容中心", role: "热点报道组", desc: "负责社会、时政与财经领域的实时报道与解读。" },
  { name: "调查组", role: "独家爆料", desc: "专注深度调查与独家线索核实，产出有分量的报道。" },
  { name: "视觉与运营", role: "编辑支持", desc: "负责内容可视化、专题编排与读者互动运营。" },
];

const partners = ["城市观察者联盟", "新媒体内容协作社", "公共传播研究中心", "社区民生服务台"];

export default function AboutPage() {
  useDocumentMeta({
    title: "关于我们_91爆料_最新热点新闻与深度爆料平台",
    description:
      "了解91爆料：一个聚焦社会热点与深度独家爆料的新闻资讯平台，覆盖娱乐、时政、科技等多个领域，坚持快速、真实、有深度的内容标准。",
    keywords: "91爆料,关于我们,新闻平台,独家报道,团队介绍",
  });

  const categories = getCategories();

  return (
    <div className="w-full">
      {/* 品牌头部 */}
      <section className="w-full bg-primary-950 py-14">
        <div className="mx-auto max-w-[1280px] px-4 md:px-6">
          <span className="inline-flex items-center gap-2 rounded-full bg-background-50/10 px-3 py-1 text-xs font-medium text-accent-400">
            <i className="ri-information-line"></i>
            关于 91爆料
          </span>
          <h1 className="mt-4 font-heading text-3xl font-black leading-tight text-background-50 md:text-4xl">
            我们只做一件事：把热点讲清楚
          </h1>
          <p className="mt-4 max-w-3xl text-sm leading-relaxed text-background-300 md:text-base">
            91爆料是一个面向普通网民与社会新闻爱好者的新闻资讯平台。我们聚焦最新热点与深度独家爆料，
            覆盖娱乐、时政、科技、社会、财经与体育等多个领域，用清晰、易读、有温度的方式，
            帮助读者快速理解每天正在发生的事。
          </p>
        </div>
      </section>

      <div className="mx-auto max-w-[1280px] px-4 py-12 md:px-6">
        {/* 发展理念 */}
        <section>
          <div className="mb-6 flex items-center gap-2">
            <span className="flex h-6 w-1.5 rounded-full bg-accent-500"></span>
            <h2 className="font-heading text-2xl font-bold text-foreground-900">我们的理念</h2>
          </div>
          <div className="grid grid-cols-1 gap-5 md:grid-cols-3">
            {philosophy.map((p) => (
              <div key={p.title} className="rounded-lg border border-background-200 bg-background-50 p-6">
                <span className="flex h-12 w-12 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                  <i className={`${p.icon} text-2xl`}></i>
                </span>
                <h3 className="mt-4 font-heading text-lg font-bold text-foreground-900">{p.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-500">{p.desc}</p>
              </div>
            ))}
          </div>
        </section>

        {/* 内容覆盖 */}
        <section className="mt-12">
          <div className="mb-6 flex items-center gap-2">
            <span className="flex h-6 w-1.5 rounded-full bg-accent-500"></span>
            <h2 className="font-heading text-2xl font-bold text-foreground-900">内容覆盖领域</h2>
          </div>
          <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
            {categories.map((cat) => (
              <Link
                key={cat.key}
                to={`/category/${cat.key}`}
                className="group rounded-lg border border-background-200 bg-background-50 p-5 transition-colors hover:border-primary-300 hover:bg-primary-50"
              >
                <div className="flex items-center justify-between">
                  <h3 className="font-heading text-lg font-bold text-foreground-900">{cat.name}</h3>
                  <i className="ri-arrow-right-line text-foreground-400 transition-colors group-hover:text-primary-600"></i>
                </div>
                <p className="mt-2 text-sm leading-relaxed text-foreground-500">{cat.description}</p>
              </Link>
            ))}
          </div>
        </section>

        {/* 团队 */}
        <section className="mt-12">
          <div className="mb-6 flex items-center gap-2">
            <span className="flex h-6 w-1.5 rounded-full bg-accent-500"></span>
            <h2 className="font-heading text-2xl font-bold text-foreground-900">团队简介</h2>
            <span className="text-sm text-foreground-400">（示例内容）</span>
          </div>
          <div className="grid grid-cols-1 gap-5 md:grid-cols-3">
            {team.map((t) => (
              <div key={t.name} className="rounded-lg border border-background-200 bg-background-50 p-6">
                <span className="flex h-12 w-12 items-center justify-center rounded-full bg-secondary-100 text-secondary-700">
                  <i className="ri-team-line text-2xl"></i>
                </span>
                <h3 className="mt-4 font-heading text-lg font-bold text-foreground-900">{t.name}</h3>
                <p className="text-xs font-medium text-accent-600">{t.role}</p>
                <p className="mt-2 text-sm leading-relaxed text-foreground-500">{t.desc}</p>
              </div>
            ))}
          </div>
        </section>

        {/* 合作伙伴 */}
        <section className="mt-12">
          <div className="mb-6 flex items-center gap-2">
            <span className="flex h-6 w-1.5 rounded-full bg-accent-500"></span>
            <h2 className="font-heading text-2xl font-bold text-foreground-900">合作伙伴</h2>
          </div>
          <div className="flex flex-wrap gap-3">
            {partners.map((p) => (
              <span
                key={p}
                className="rounded-lg border border-background-200 bg-background-50 px-5 py-3 text-sm font-medium text-foreground-700"
              >
                {p}
              </span>
            ))}
          </div>
        </section>

        {/* 返回入口 */}
        <div className="mt-12 flex flex-wrap gap-3 border-t border-background-200 pt-8">
          <Link
            to="/"
            className="cursor-pointer whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            返回首页
          </Link>
          <Link
            to="/contact"
            className="cursor-pointer whitespace-nowrap rounded-md border border-background-300 px-5 py-2.5 text-sm font-medium text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600"
          >
            联系我们
          </Link>
        </div>
      </div>
    </div>
  );
}